<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>

    <template #pageActions>
      <div
        class="mb-12 flex flex-col space-y-16 md:mb-0 md:flex-row md:space-x-16 md:space-y-0"
      >
        <RevButton
          full-width="adaptive"
          variant="secondary"
          @click="handleOpenImportExportDrawer"
        >
          {{ i18n(translations.importExport) }}
        </RevButton>

        <RevButton
          full-width="adaptive"
          :to="{ name: ROUTE_NAMES.OPTIONS.PRICING }"
          variant="secondary"
        >
          {{ i18n(translations.managePriceRules) }}
        </RevButton>

        <RevButton
          full-width="adaptive"
          :to="{ name: ROUTE_NAMES.LISTINGS.PRODUCT.SEARCH }"
          variant="primary"
        >
          {{ i18n(translations.create) }}
        </RevButton>
      </div>
    </template>

    <template #pageContent>
      <DealsBanner v-if="isDealsBannerEnabled" class="my-32" />

      <NavTabs
        :index-route-name="ROUTE_NAMES.LISTINGSV2.INDEX"
        :label="translations.navigation"
      />

      <ImportExportDrawer />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'

import { ROUTE_NAMES } from '~/constants/routes'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import { MODAL_NAME as LISTINGS_IMPORT_EXPORT_DRAWER_MODAL_NAME } from '../index/components/ImportExportDrawer/ImportExportDrawer.constants'
import ImportExportDrawer from '../index/components/ImportExportDrawer/ImportExportDrawer.vue'

import translations from './Index.translations'
import DealsBanner from './components/DealsBanner/DealsBanner.vue'

const i18n = useI18n()

const { isFeatureEnabled } = useBusinessFeaturesStore()
const isDealsBannerEnabled = isFeatureEnabled('isDealsBannerEnabled')

function handleOpenImportExportDrawer() {
  openModal(LISTINGS_IMPORT_EXPORT_DRAWER_MODAL_NAME)
}
</script>
